export enum FacultyType {
  FME = 'FME',
  DEE = 'DEE',
  FCE = 'FCE',
  FChE = 'FChE',
  CSE = 'CSE',
  GEOPET = 'GEOPET',
  FAS = 'FAS',
  FMT = 'FMT',
  FTE = 'FTE',
  SIM = 'SIM',
  FENR = 'FENR',
  IMTC = 'IMTC',
  PFIEV = 'PFIEV',
  OISP = 'OISP',
}

export const FACULTY_OPTIONS = [
  {
    value: FacultyType.FME,
    label: 'Khoa Cơ khí',
  },
  {
    value: FacultyType.DEE,
    label: 'Khoa Điện - Điện tử',
  },
  {
    value: FacultyType.FCE,
    label: 'Khoa Kỹ thuật Xây dựng',
  },
  {
    value: FacultyType.FChE,
    label: 'Khoa Kỹ thuật Hóa học',
  },
  {
    value: FacultyType.CSE,
    label: 'Khoa Khoa học và Kỹ thuật Máy tính',
  },
  {
    value: FacultyType.GEOPET,
    label: 'Khoa Kỹ thuật Địa chất và Dầu khí',
  },
  {
    value: FacultyType.FAS,
    label: 'Khoa Khoa học Ứng dụng',
  },
  {
    value: FacultyType.FMT,
    label: 'Khoa Công nghệ Vật liệu',
  },
  {
    value: FacultyType.FTE,
    label: 'Khoa Kỹ thuật Giao thông',
  },
  {
    value: FacultyType.SIM,
    label: 'Khoa Quản lý Công nghiệp',
  },
  {
    value: FacultyType.FENR,
    label: 'Khoa Khoa học Môi trường và Tài nguyên',
  },
  {
    value: FacultyType.IMTC,
    label: 'Trung tâm Đào tạo Bảo dưỡng Công nghiệp',
  },
  {
    value: FacultyType.PFIEV,
    label: 'Chương trình chất lượng cao Việt - Pháp',
  },
  {
    value: FacultyType.OISP,
    label: 'Văn phòng Đào tạo Quốc tế',
  },
];
